import React from 'react'
import WeekDayCard from './WeekDayCard'
import { Grid } from '@mui/material'
import { WallboxSettingsFormModel } from 'src/Libs/wallboxes/models'
import { ALL_DAYS } from '@e3dc-react/shell/Libs/date/types'

interface Props {
  name: keyof WallboxSettingsFormModel
  disabled?: boolean
}

/**
 * display the weekday cards in grid
 */
const WeekDayList: React.FC<Props> = ({ name, disabled = false }) => {
  return (
    <Grid container>
      {ALL_DAYS.map(weekDayName => (
        <Grid key={weekDayName} item xs={12} md={6}>
          <WeekDayCard name={name} weekDayName={weekDayName} disabled={disabled} />
        </Grid>
      ))}
    </Grid>
  )
}

export default WeekDayList
